import type { PropsWithChildren } from 'react';

import { cn } from '@/shared/helpers';

type PageProps = PropsWithChildren<{
  className?: string;
}>;

export function Page({ children, className }: PageProps) {
  return (
    <div className={cn('@container flex h-full min-h-0 w-full flex-1 flex-col', className)}>
      {children}
    </div>
  );
}

type PageContentProps = PropsWithChildren<{
  variant: 'column' | 'split';
  className?: string;
}>;

export function PageContent({ variant, className, children }: PageContentProps) {
  return (
    <div
      className={cn(
        'flex min-h-0 flex-1 p-(--page-inset)',
        {
          'flex-col gap-4 overflow-y-auto': variant === 'column',
          'flex-col gap-5 overflow-y-auto @2xl:flex-row @2xl:gap-0 @2xl:overflow-hidden @2xl:p-0':
            variant === 'split',
        },
        className,
      )}
    >
      {children}
    </div>
  );
}

export function DetailMain({ children }: PropsWithChildren) {
  return (
    <div className="order-2 min-h-0 min-w-0 shrink-0 @2xl:order-none @2xl:flex-1 @2xl:overflow-x-hidden @2xl:overflow-y-auto">
      <div className="flex min-w-0 flex-col gap-4 *:shrink-0 @2xl:mx-auto @2xl:max-w-5xl @2xl:p-(--page-inset)">
        {children}
      </div>
    </div>
  );
}

export function DetailSide({ children }: PropsWithChildren) {
  return (
    <aside className="order-1 min-h-0 w-full min-w-0 shrink-0 transition-[width] @2xl:order-none @2xl:w-80 @2xl:overflow-x-hidden @2xl:overflow-y-auto @2xl:border-l @5xl:w-96">
      <div className="flex min-w-0 flex-col gap-5 *:shrink-0 @2xl:p-(--page-inset) @2xl:pl-5">
        {children}
      </div>
    </aside>
  );
}
